import {
  mapRenderer,
  NumberRenderer,
  ReadOnlySwitchRenderer,
  StringRenderer,
} from "../shared/renderers/table";
import { IntlShape } from "react-intl";
import { TableColumns } from "../shared/crud/list";
import { lockTypeMessage, tableHeaderMessages, tableValuesMessages, typeMessage } from "./messages";
import { getLanguageFromFullLocale } from "../../lib/config";
import { CustomExtraListItem, ExtraRateType, ExtraUse } from "./types";
import { dateToString } from "../../lib/dateUtils";

export default function getTableColumns(intl: IntlShape): TableColumns<CustomExtraListItem> {
  return {
    active: {
      renderer: ReadOnlySwitchRenderer,
    },
    ticker: {
      renderer: StringRenderer,
    },
    translationsList: {
      width: 200,
      renderer: mapRenderer(StringRenderer, (v) => {
        const current = v.find(t => {
          return t.locale === getLanguageFromFullLocale(intl.locale);
        });
        return current?.name || v[0].name;
      }),
    },
    type: {
      renderer: mapRenderer(StringRenderer, (v) => {
        return intl.formatMessage(typeMessage[v]);
      }),
    },
    rate: {
      renderer: mapRenderer(StringRenderer, (v) => {
        return v === ExtraRateType.EXTRA_RATE_TYPE_OWN
          ? intl.formatMessage(tableValuesMessages.rateTypeOwn)
          : v.toString();
      }),
    },
    travelWindow: {
      width: 180,
      renderer: mapRenderer(StringRenderer, (v) => {
        const startDate = v.startDate ? dateToString(new Date(v.startDate), "dd/MM/yyyy") : "";
        const endDate = v.endDate ? dateToString(new Date(v.endDate), "dd/MM/yyyy") : "";
        return `${startDate} - ${endDate}`;
      }),
    },
    availability: {
      renderer: mapRenderer(StringRenderer, (v) => {
        return v === ExtraUse.EXTRA_USE_OWN ? intl.formatMessage(tableValuesMessages.rateTypeOwn) : "";
      }),
    },
    blockage: {
      renderer: mapRenderer(StringRenderer, (v) => {
        return v === ExtraUse.EXTRA_USE_OWN ? intl.formatMessage(tableValuesMessages.rateTypeOwn) : "";
      }),
    },
    lockType: {
      renderer: mapRenderer(StringRenderer, (v) => {
        return intl.formatMessage(lockTypeMessage[v]);
      }),
    },
    emailsList: {
      width: 200,
      renderer: mapRenderer(StringRenderer, (v) => {
        return v.join(", ");
      }),
    },
    minStay: {
      align: "center",
      renderer: mapRenderer(NumberRenderer, (v) => {
        return v;
      }),
    },
    maxStay: {
      align: "center",
      renderer: mapRenderer(NumberRenderer, (v) => {
        return v;
      }),
    },
    minNotice: {
      align: "center",
      renderer: mapRenderer(NumberRenderer, (v) => {
        return v;
      }),
    },
    maxNotice: {
      align: "center",
      renderer: mapRenderer(NumberRenderer, (v) => {
        return v;
      }),
    },
    codesList: {
      renderer: mapRenderer(StringRenderer, (v) => {
        return v.join(", ");
      }),
    },
    isShared: {
      renderer: mapRenderer(StringRenderer, (v) => {
        return v ? intl.formatMessage(tableHeaderMessages.sharedUse) : "";
      }),
    }
  };
}
